import { render, staticRenderFns } from "./debits.vue?vue&type=template&id=4ec398c4&"
import script from "./debits.vue?vue&type=script&lang=js&"
export * from "./debits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports